module.exports = __webpack_public_path__ + "img/eprice-button-secondary.b58c8e96.png";